export default "__VITE_ASSET__BQ4Ja_J2__"